import { Category1Types } from 'enums/category1Enums';
import { FormType } from 'enums/FieldTypeEnums';
import React, { FC } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import FieldsRow from 'shared/components/FieldsRow';
import { getOriginsData } from './category1Utils';
import { ScopeThreeCategoryOne } from 'models/ScopeThreeCategoryOne/ScopeThreeCategoryOne.model';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import { BestFitRegion } from 'models/BestFitRegion/bestFitRegion.model';

interface OriginsLayoutProps {
  index: number;
  type: Category1Types;
  originIndex: number;
  removeOrigin?: (index?: number) => void;
  bestFitRegion?: BestFitRegion[];
  setValue?: UseFormSetValue<ScopeThreeCategoryOne>;
  setIsAddRegion?: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  originsLength?: number;
}

const OriginsLayout: FC<OriginsLayoutProps> = ({
  bestFitRegion,
  ...remainingProps
}) => {
  const orginsData = getOriginsData({
    bestFitRegionOptions: bestFitRegion,
    ...remainingProps,
  });
  return <FieldsRow {...orginsData} formType={FormType.REACT_HOOK_FORMS} />;
};

export default OriginsLayout;
